<ng-template #modalContent>
  <ng-content></ng-content>
</ng-template>